<template>
  <div class="cropper-tc relativeItem" @touchmove.prevent>
    <div class="upload-demo absoluteItem" v-show="show_up_demo">
      <div class="d1">
        <p class="p1">{{ title }}</p>
        <p class="p2">{{ sub }}</p>
        <p class="p3" @click="choose_video" :class="{ clicked: clicked_btn }">
          选择视频
        </p>
      </div>
      <div
        class="d2"
        @click="dialogVisible_video"
        :class="{ clicked: clicked_btn }"
      >
        取消
      </div>

      <input type="file" id="video-up-input" @change="changeUpload_input" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CropperImage",
  props: ["img_item_id", "title", "sub", "time"],
  data() {
    return {
      clicked_btn: false, //是否点击按钮 增加点击样式
      show_up_demo: true,
    };
  },
  methods: {
    //关闭组件弹窗
    dialogVisible_video() {
      let _this = this;
      this.clicked_btn = true;
      setTimeout(() => {
        _this.clicked_btn = false;
      }, 300);
      this.show_up_demo = true;
      document.querySelector("#video-up-input").value = "";
      this.$emit("close_upvideo");
    },

    //打开input
    choose_video() {
      let _this = this;
      this.clicked_btn = true;
      setTimeout(() => {
        _this.clicked_btn = false;
      }, 300);
      let input = document.querySelector("#video-up-input");
      input.click();
    },

    // 限制视频大小
    changeUpload_input(e) {
      let _this = this,
        // fr = new FileReader(),
        obj = e.target.files[0],
        filePath = e.target.value;
      if (
        filePath.indexOf("avi") != -1 ||
        filePath.indexOf("mp4") != -1 ||
        filePath.indexOf("rm") != -1 ||
        filePath.indexOf("rmvb") != -1 ||
        filePath.indexOf("flv") != -1 ||
        filePath.indexOf("mpg") != -1 ||
        filePath.indexOf("mov") != -1 ||
        filePath.indexOf("mkv") != -1 ||
        filePath.indexOf("AVI") != -1 ||
        filePath.indexOf("MP4") != -1 ||
        filePath.indexOf("RM") != -1 ||
        filePath.indexOf("RMVB") != -1 ||
        filePath.indexOf("FLV") != -1 ||
        filePath.indexOf("MPG") != -1 ||
        filePath.indexOf("MOV") != -1 ||
        filePath.indexOf("MKV") != -1
      ) {
        // fr.readAsDataURL(img_obj);
        // fr.onload = function (res) {
        //   _this.option.img = res.target.result;
        //   _this.show_up_demo = false;
        // };

        //限制上传视频的时长
        var content = obj;
        var url = URL.createObjectURL(content); //获取录音时长
        var audioElement = new Audio(url); //audio也可获取视频的时长
        var duration;
        audioElement.addEventListener("loadedmetadata", function () {
          duration = audioElement.duration;
          if (duration > _this.time * 1 + 1) {
            //超过了最大限定时间（秒）
            _this.$tool.tip(`上传视频时长不能超过${_this.time}秒`, "50%");
          } else {
            //获取可以预览的视频地址
            let video_url = _this.getObjectURL(obj);
            let data = {
              url: video_url,
              video: obj, //视频的blob格式资源
            };
            _this.$emit("uploadVideoSuccess", data);
          }
        });
      } else {
        _this.$tool.tip("上传文件类型有误", "50%");
      }
      _this.dialogVisible_video();
    },

    /**制作可预览的视频链接 */
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
  },
  mounted: function () {},
};
</script>

<style scoped>
.cropper-tc {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 19;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
}
.upload-demo {
  padding: 0 10px;
  width: 100%;
  text-align: center;
  bottom: 0;
  left: 0;
  animation: show 0.4s;
  -webkit-animation: show 0.4s;
  /* Safari 和 Chrome */
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.upload-demo > div {
  border-radius: 4px;
  background: #fff;
  text-align: center;
  padding: 0 5px;
}
.upload-demo .p1 {
  font-size: 14px;
  color: #666;
  padding-top: 16px;
}
.upload-demo .p2 {
  font-size: 12px;
  color: #999;
  padding-bottom: 16px;
  border-bottom: 1px solid #f4f4f4;
}
.upload-demo .p3 {
  font-size: 16px;
  color: #5c61f1;
  padding: 11px 0;
}
.upload-demo .d2 {
  font-size: 16px;
  color: #666;
  padding: 10px 0;
  margin: 10px 0 20px 0;
}
.upload-demo input {
  visibility: hidden;
}
.upload-demo .clicked {
  background: #f4f4f4;
}
</style>
